import styled from 'styled-components';

const JourneyContextSelectorContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export { JourneyContextSelectorContainer };
